import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import Bugsnag from '@bugsnag/js'
import {BugsnagErrorHandler} from '@bugsnag/plugin-angular'

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {environment} from "../environments/environment";
import {SharedModule} from "./shared/shared.module";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from "@angular/common/http";
import {MaterialElevationDirective} from "./directives/material-elevation.directive";
import {FormsModule} from "@angular/forms";
import { inject } from "@vercel/analytics";

// Extend Window type with webkit property,
// required to check if iOS is running within a WKWebView browser instance.
declare global {
  interface Window {
    webkit?: any;
  }
}

const BUGSNAG_AGENT_URL = 'https://bugs-api.vuframe.com';
// cookies=0 / isolate=1: nothing may be written to the device
const params = new URLSearchParams(location.search);
const allowsDeviceStorage = params.get('cookies') !== '0' && params.get('isolate') !== '1';
// configure Bugsnag
Bugsnag.start({
  apiKey: atob(environment.BUGSNAG_API_KEY),
  autoTrackSessions: false,
  generateAnonymousId: allowsDeviceStorage,
  appType: 'browser',
  appVersion: environment.version,
  releaseStage: environment.stage,
  logger: null,
  endpoints: {
    notify: BUGSNAG_AGENT_URL,
    sessions: BUGSNAG_AGENT_URL
  }
})
Bugsnag.startSession();

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  return new BugsnagErrorHandler()
}

// vercel analytics
if (environment.vercelAnalytics) { inject(); }

@NgModule({
  declarations: [
    AppComponent,
    MaterialElevationDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
  ],
  providers: [{provide: ErrorHandler, useFactory: errorHandlerFactory}],
  bootstrap: [AppComponent]
})
export class AppModule {
}
